import React from 'react'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'
import moment from 'moment'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import updateLocale from 'dayjs/plugin/updateLocale'

import english from './locales/en-US'
import french from './locales/fr-FR'
import russian from './locales/ru-RU'
import chinese from './locales/zh-CN'
import deutsch from './locales/de-DE'

const locales = {
  'en-US': english,
  'fr-FR': french,
  'ru-RU': russian,
  'zh-CN': chinese,
  'de-DE': deutsch,
}

@connect(({ settings }) => ({ settings }))
class Localization extends React.Component {
  render() {
    const {
      children,
      settings: { locale },
    } = this.props
    let currentLocale = locales[locale]
    if (currentLocale === undefined) currentLocale = locales['en-US']

    moment.locale('en', {
      week: {
        dow: 1,
      },
    })

    dayjs.extend(updateLocale)

    dayjs.updateLocale('en', {
      weekStart: 1,
    })
    // console.log('dayjs locale', dayjs.locale())

    // console.log('currentLocale', currentLocale)
    return (
      <ConfigProvider
        locale={currentLocale.localeAntd}
        // Global fix for dropdowns (Select/DatePicker/Dropdown) jumping while a
        // scrollable container (modal/drawer/form) is scrolled: render each popup
        // inside its own trigger's parent so it scrolls WITH the content instead
        // of being repositioned against document.body on every scroll event.
        // Guard: some popups (Modal, notification, message) call this with no
        // trigger node - fall back to document.body so we never deref undefined.
        getPopupContainer={triggerNode =>
          triggerNode && triggerNode.parentNode ? triggerNode.parentNode : document.body
        }
      >
        <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
          {children}
        </IntlProvider>
      </ConfigProvider>
    )
  }
}

export default Localization
